import script from "./RecommendOrderField.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendOrderField.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendOrderField.vue?vue&type=style&index=0&id=3467aa13&lang=scss&scoped=true"
import "./RecommendOrderField.vue?vue&type=style&index=1&id=3467aa13&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3467aa13"]])

export default __exports__